import type { FrameRate } from "opencut-wasm";

export const DEFAULT_FPS: FrameRate = { numerator: 30, denominator: 1 };
